import React from 'react';

import Button from 'react-bootstrap/Button';

import Lock from '../../Icons/lock.jsx';
import Authentication from '../../Utilities/Authentication/index.jsx';

import ArticleExcerpt from '../ArticleExcerpt/index.jsx';
import CMSContent from '../CMSContent/index.jsx';

import BEM from '@scripts/utilities/bem.js';
import CurrentUser from '@scripts/utilities/current-user.js';


class LockScreen extends React.Component {
  render() {
    var titleHtml = {
      __html: this.props.title
    };
    var featureImage;
    var lockContent;

    if (this.props.image) {
      featureImage = (
        <div className="cs-locked-article-preview__image">
          <img src={this.props.image} className="img-fluid" />
        </div>
      );
    }

    if (CurrentUser && CurrentUser.activeMember) {
      lockContent = (
        <>
            <h2 className="cs-lock-screen__title">
              Access {this.props.membershipLevel} Content
            </h2>
            <CMSContent>
                <p>
                    Upgrade your Collective Shift Membership to {this.props.membershipLevel} to unlock our member-only research and insights.
                </p>
                <div className="cs-block-button">
                    <Button href="/my-account/subscriptions/">
                        Upgrade your membership to {this.props.membershipLevel}
                    </Button>
                </div>
            </CMSContent>
        </>
      );
    } else {
      var tmp = [];

      tmp.push(
        <p key="intro">
            Start your Collective Shift Membership to unlock our member-only research and insights.
        </p>
      );

        tmp.push(
          <div className="cs-block-button" key="button">
              <Button href="/become-a-member/" variant="gradient">
                  Start Now
              </Button>
          </div>
        );

      if (! CurrentUser) {
        tmp.push(
          <p key="login"><small>Already a member? <a href={Authentication.getLoginUrl()}>Login</a></small></p>
        );
      }

      lockContent = (
          <>
              <h2 className="cs-lock-screen__title">
                  Access Premium Content
              </h2>
              <CMSContent>
                  {tmp}
              </CMSContent>
          </>
      );
    }

    return (
      <div className={BEM.classString('cs-locked-article-preview', 'modal')}>
        <div className="cs-locked-article-preview__header">
          <h1 className="cs-page-title" dangerouslySetInnerHTML={titleHtml} />
          {featureImage}
        </div>
        <div className="cs-locked-article-preview__content">
          <ArticleExcerpt excerpt={this.props.excerpt} />
        </div>
        <div className="cs-locked-article-preview__lock">
          <div className="cs-lock-screen">
            <div className="cs-lock-screen__fade" />
            <div className="cs-lock-screen__content">
              <div className="cs-lock-screen__container">
                <div className="cs-lock-screen__icon">
                  <Lock />
                </div>
                {lockContent}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LockScreen;

